import { AvField, AvForm } from "availity-reactstrap-validation";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { apiZoneGet, apiZoneSave } from "../../../api/zone";
import local from "../../../localization/strings";

const ZoneEdit = ({ buildingId, zoneId, zoneEdit, cancel, saved }) => {
	const [data, setData] = useState(undefined);

	useEffect(() => {
		const LoadData = async () => {
			const result = await apiZoneGet(buildingId, zoneId);

			setData(result);
		};

		if (zoneEdit) {
			if (zoneId) {
				LoadData();
			} else {
				setData({ name: "" });
			}
		} else {
			setData(undefined);
		}
	}, [buildingId, zoneId, zoneEdit]);

	async function save(_e, values) {
        await apiZoneSave(zoneId, buildingId, values.name, data.index);
        
        saved();
	}

	return (
		<Modal isOpen={zoneEdit} toggle={cancel} centered backdrop="static">
			<ModalHeader toggle={cancel}>{local.TS_Zone}</ModalHeader>
			<ModalBody>
				{data && (
					<AvForm model={data} onValidSubmit={async (e, values) => await save(e, values)}>
						<AvField name="name" label={local.TS_Name} validate={{ required: { value: true, errorMessage: local.TS_Required } }} maxLength={30} />

						<Row>
							<Col>
								<Button color="primary" className="mt-2 float-left">
									{local.TS_Save}
								</Button>
								<Button color="secondary" className="mt-2 ml-2 float-left" type="button" onClick={cancel}>
									{local.TS_Cancel}
								</Button>
							</Col>
						</Row>
					</AvForm>
				)}
			</ModalBody>
		</Modal>
	);
};

export default ZoneEdit;
